import { render, staticRenderFns } from "./TabGeneralProtocol.vue?vue&type=template&id=74338dfc&scoped=true"
import script from "./TabGeneralProtocol.vue?vue&type=script&lang=js"
export * from "./TabGeneralProtocol.vue?vue&type=script&lang=js"
import style0 from "./TabGeneralProtocol.vue?vue&type=style&index=0&id=74338dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74338dfc",
  null
  
)

export default component.exports